import { buildMultilineAction, quoteRe } from '../utils'

type QuoteCtx = {
  allQuotes: boolean
}

const computeQuoteContext = (info: { lines: string[] }): QuoteCtx => {
  const allQuotes = info.lines.every((ln) => quoteRe.test(ln))
  return { allQuotes }
}

const buildQuoteTransformer = (ctx: QuoteCtx) => (ln: string) => {
  const { allQuotes } = ctx
  let outLn = ln
  if (allQuotes) {
    const m = ln.match(quoteRe)
    if (m) {
      outLn = ln.slice(m[0].length)
    }
  } else if (!quoteRe.test(ln)) {
    outLn = '> ' + ln
  }
  return outLn
}

export const toggleQuoteAction = buildMultilineAction(
  computeQuoteContext,
  buildQuoteTransformer,
)
